<template>
  <div class="featured-carousel-wrapper">
    <product-hero-carousel
      :items="carouselItems"
    />
  </div>
</template>

<script>
import productHeroCarousel from './featured-carousel/product-hero-carousel.vue'

export default {
  name: 'featured-carousel',
  components: {
    productHeroCarousel
  },
  props: {
    filestore: {
      type: Object,
      required: false,
      default: () => { return {} }
    },
    widget: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  data() {
    return {
      // onlyOnHover: false, //if set, we only show play the video on hover

    }
  },
  computed: {
    settings() {
      return this.widget.widgetSettings.featuredCarousel
    },
    carouselItems() {
      // return testItems
      // const a = this.widget.featuredCarouselItems
      // debugger
      return this.widget.featuredCarouselItems
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.featured-carousel-wrapper{
  max-width: var(--featured-carousel-wrapper-width, 1140px);
  margin: 0 auto;
  padding: 0 15px;
}
</style>
